import styles from "../components/TeamSettings.module.css";
import React, { useRef } from "react";
import { weekDayOptions } from "../config/dayOptions";

type DaySelectProps = {
  reportDay: string;
  disabled?: boolean;
  onReportDayChange?: (day: string) => void;
};

export const DaySelect = ({
  reportDay,
  disabled = true,
  onReportDayChange,
}: DaySelectProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div ref={containerRef}>
      <div
        className="select-component__duration-section"
        style={{ marginTop: "0", marginBottom: "0" }}
      >
        <div className="duration-field-row">
          <p>Report day</p>
          <select
            className={styles["team-settings-invite-form-input"]}
            style={{ marginLeft: "12px" }}
            value={reportDay}
            disabled={disabled}
            onChange={(event) => onReportDayChange?.(event.target.value)}
            aria-label="Report day"
          >
            <option value="">Not set</option>
            {weekDayOptions.map((day) => (
              <option key={day} value={day} style={{ fontWeight: "600" }}>
                {day}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};
